export default {
  title: "Additional Info",
  peek_access: "Peek Access",
  label_peek_access: "Peek Access",
  edit_peek_access: "Edit Peek Access",
  hide_field: "*****",
  placeholder_input: "type something",
  edit_info: "Edit Info",
};
